import { COMMENT, DECLARATION, IMPORT, RULESET } from 'stylis';
export function serialize(elements, callback) {
    let output = '';
    for(let i = 0; i < elements.length; i++){
        output += callback(elements[i], i, elements, callback) || '';
    }
    return output;
}
export function stringify(element, _index, _elements, callback) {
    switch(element.type){
        case IMPORT:
        case DECLARATION:
            element.return = element.return || element.value;
            return element.return;
        case COMMENT:
            return '';
        case RULESET:
            element.value = element.props.join(',');
            break;
        default:
            break;
    }
    const children = serialize(element.children, callback);
    if (children.length) {
        element.return = `${element.value}{${children}}`;
        return element.return;
    }
    return '';
}

//# sourceMappingURL=serialize.js.map